import React, { JSX } from 'react';
import { Box, Heading } from '@chakra-ui/react';
import { useTranslations } from 'contexts/LocalizationContext';

import { useToast } from '../../common/components';
import { useSendMessage } from '../../services/messages';
import MessagesForm from './MessagesForm';

type MessageFormValues = {
  userId: string;
  content: string;
};

const Messages = (): JSX.Element => {
  const translations = useTranslations();
  const { displayToast } = useToast();
  const { mutate, isLoading } = useSendMessage();

  const handleSubmit = (values: MessageFormValues) => {
    mutate(values, {
      onSuccess: () => {
        displayToast('success', translations('messages_form_success'));
      },
      onError: (error) => {
        displayToast('error', error.response?.data.message || translations('messages_form_error'));
      },
    });
  };

  return (
    <Box>
      <Heading as="h1" size="lg" mb={6}>
        {translations('messages_title')}
      </Heading>
      <MessagesForm isLoading={isLoading} onSubmit={handleSubmit} />
    </Box>
  );
};

export default Messages;
